module.exports = __webpack_public_path__ + "img/avatar.6a3966fb.svg";